import { Center, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { TextSerif } from "@/components/elements";

interface Props {
  type?: "all" | "delivered" | "read";
}

const NotificationEmptyState = ({ type }: Props) => {
  const { t } = useTranslation();

  const emptyTitle =
    type === "read"
      ? t("components.NotificationMenu.read_notification_empty_message")
      : t("components.NotificationMenu.empty_message");

  return (
    <Center>
      <Stack gap="sm" maw="100%" w={250}>
        <Title fz="sm" ta="center">
          {emptyTitle}
        </Title>

        {type !== "read" && (
          <TextSerif fz="sm" ta="center">
            {t("components.NotificationMenu.empty_description")}
          </TextSerif>
        )}
      </Stack>
    </Center>
  );
};

export default NotificationEmptyState;
